export default "__VITE_ASSET__DTqr4ig1__"